import { Component, ElementRef, Inject, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-docs-viewer',
  templateUrl: './docs-viewer.component.html',
  styleUrls: ['./docs-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocsViewerComponent implements AfterViewInit {

  url: any
  extension: any
  constructor(
    public dialogRef: MatDialogRef<DocsViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.url = data?.documentUrl
    this.extension = (this.url.split('.'))[this.url.split('.').length - 1]
  }

  downloadDoc() {
    const link = document.createElement('a');
    link.href = this.url;
    link.download = this.getFileNameFromUrl(this.url);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  getFileNameFromUrl(url: string): string {
    return url.split('/').pop() ?? 'document';
  }
  @ViewChild('viewerWrapper') viewerWrapper!: ElementRef;
  isLoading = true;

  ngAfterViewInit() {
    requestAnimationFrame(() => {
      const iframe = this.viewerWrapper.nativeElement.querySelector('iframe');
      if (iframe) {
        iframe.onload = () => {
          this.isLoading = false;
          this.cdr.markForCheck();
        };
      }
    });
  }

  close() {
    this.dialogRef.close();
  }
}
